module.exports = __webpack_public_path__ + "img/ld.82128d24.png";